<template>
    <div class="reportForWeek">
        <div class="reportForWeek-title bigBorder">
            <div class="mainTitle">
                Итоги <span v-if="msg.ReportType === 'week'">{{new Date(msg.ReportDate).getWeek()}}</span> {{reportType[msg.ReportType].title}} <span v-if="msg.ReportType === 'day'" style="margin-right:12px; font-size:16px">{{new Date(msg.ReportDate).getDate()+'.'+(new Date(msg.ReportDate).getMonth() + 1) + '.' + new Date(msg.ReportDate).getFullYear()}}</span>
                <span v-if="msg.ReportType === 'month'" style="margin-right:8px; font-size:15px">{{monthes[new Date(msg.ReportDate).getMonth()]}}</span><span v-if="msg.ReportType === 'month'" style="margin-right:12px;text-transform:none;">{{new Date(msg.ReportDate).getFullYear()}} г.</span>
                <p :class="msg.ProfitAbs > 0 ? 'color-green':'color-red'"><i :class="msg.ProfitAbs > 0 ? 'icon-arrow-up':'icon-arrow-down'" />$ {{$moneyf(msg.ProfitAbs)}}  <i :class="msg.ProfitAbs > 0 ? 'icon-arrow-up':'icon-arrow-down'" />% {{$moneyf(msg.ProfitRel)}}</p>
                <!--<span :class="profitType[msg.ReportType].profitAbs > 0 ? 'color-green' : 'color-red'">$ {{$moneyf(profitType[msg.ReportType].profitAbs)}} % {{$moneyf(profitType[msg.ReportType].profitRel)}}</span>-->
            </div>
        </div>
        <div class="reportForWeek-title">
            <div><span>ОТКРЫТЫЕ ПОЗИЦИИ</span> ВСЕГО ЗА {{reportType[msg.ReportType].titleOrders}} Было открыто <span>{{!msg.OpenedOrders ? 0 : msg.OpenedOrders.length}}</span> сделок (совокупно)</div>
        </div>
        <table class="reportTable bigBorder">
            <tr class="reportTable-title">
                <th>Ордер</th>
                <th>Тип</th>
                <th>Объём</th>
                <th>Вход</th>
            </tr>
            <tr v-for="(item,index) in getReportDataOpenPositionsBySymbol" :key="index">
                <td>{{item.symbol}}</td>
                <td :class="item.cmd < 0 ? 'color-red' : 'color-green'">{{item.cmd < 0 ? 'SELL' : 'BUY'}}</td>
                <td>{{$moneyf(item.volume)}}</td>
                <td>{{item.price}}</td>
            </tr>
        </table>
        <div style="border-top: solid #293546 1px;" class="reportForWeek-title">
            <div><span>ЗАКРЫТЫЕ ПОЗИЦИИ</span> ВСЕГО ЗА {{reportType[msg.ReportType].titleOrders}} Было закрыто <span>{{!msg.ClosedOrders ? 0 : msg.ClosedOrders.length}}</span> СДЕЛОК (совокупно)</div>
        </div>
        <div class="tableWrap bigBorder">
            <div v-show="widthTable > 340 && !extendStatus" class="tableOverlay"></div>
            <table ref="tableOrders" class="reportTable">
                <tr class="reportTable-title">
                    <th>Ордер</th>
                    <th>Тип</th>
                    <th>Объём</th>
                    <th>PL,$</th>
                    <th>PL,%</th>
                    <th>PL,P</th>
                </tr>
                <tr v-for="(item,index) in getReportDataClosePositionsBySymbol" :key="index + 'c'">
                    <td>{{item.symbol}}</td>
                    <td :class="item.cmd < 0 ? 'color-red':'color-green'">{{item.cmd < 0 ? 'SELL' : 'BUY'}}</td>
                    <td>{{item.volume}}</td>
                    <td :class="item.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(item.plDepo)}}</td>
                    <td :class="item.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(item.plRel)}}</td>
                    <td :class="item.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(item.plPoint)}}</td>
                </tr>
                <tr>
                    <td colspan="2">ИТОГО:</td>
                    <td>{{getSummaryProfits.volume}}</td>
                    <td :class="getSummaryProfits.plDepo < 0 ? 'color-red':'color-green'">{{$moneyf(getSummaryProfits.plDepo)}}</td>
                    <td :class="getSummaryProfits.plRel < 0 ? 'color-red':'color-green'">{{$moneyf(getSummaryProfits.plRel)}}</td>
                    <td :class="getSummaryProfits.plPips < 0 ? 'color-red':'color-green'">{{getSummaryProfits.plPips ? getSummaryProfits.plPips.toFixed(2) : 0}}</td>
                </tr>
            </table>
        </div>
        <div v-if="msg.LastDay" class="reportSummaryInfo">
            <div class="reportSummaryInfo-item">
                <span>Баланс</span> <i :class="getSummaryProfits.plDepo >= 0 ? 'icon-arrow-up color-green':'icon-arrow-down color-red'" /><span :class="getSummaryProfits.plDepo >= 0 ? 'color-green' : 'color-red'"> $ {{$moneyf(msg.LastDay.BalanceClose)}}</span>
            </div>
            <div class="reportSummaryInfo-item">
                <span>Средства</span> <i :class="msg.ProfitAbs > 0 ? 'icon-arrow-up color-green':'icon-arrow-down color-red'" /><span :class="msg.ProfitAbs > 0 ? 'color-green' : 'color-red'"> $ {{$moneyf(msg.LastDay.EquityClose)}}</span>
            </div>
            <div class="reportSummaryInfo-item">
                <span>Текущий доход</span> <i :class="msg.ProfitAbs > 0 ? 'icon-arrow-up color-green':'icon-arrow-down color-red'" /><span :class="msg.ProfitAbs < 0 ? 'color-red' : 'color-green'"> $ {{$moneyf(msg.LastDay.EquityClose - msg.LastDay.BalanceClose)}}</span>
            </div>
            <div class="reportSummaryInfo-item">
                <span style="margin-right:6px;">Кредитное плечо</span> <span>{{ msg.LastDay.Leverage.toFixed(2)}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
    props:['msg','extendStatus'],
    data() {
        return {
            profit:0,
            profitPercent:0,
            monthes:['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            statWeek:{
                week:[]
            },
            widthTable:0,
            reportType: {
                week: {
                    title:'торговой недели',
                    titleOrders:'неделю',
                    profit:0
                },
                day: {
                    title:'торгового дня',
                    titleOrders:'день',
                    profit:0
                },
                month: {
                    title:'торгового месяца',
                    titleOrders:'месяц',
                    profit:0
                }
            },
        }
    },
    watch: {
        extendStatus: function() {
            setTimeout(()=> {
                this.getHeightTable();
            },700);   
        }
    },
    computed: {
        ...mapGetters({
              getCropStat: 'accountstat/getCroppedStatBySymbol',
              getMonthStat: 'accountstat/getMonthStat',
        }),
        getReportDataOpenPositionsBySymbol() {
            if(!this.msg.OpenedOrders || !this.msg.OpenedOrders.length === 0)
                return 0
            let arrSymbols = getSymbolPair(this.msg.OpenedOrders);
            let result = []
            for(let i = 0; i < arrSymbols.length; i++) {
                result.push({
                    symbol:arrSymbols[i],
                    volume:getVolumeBySymbol(arrSymbols[i], this.msg.OpenedOrders),
                    price: getAverPrice(arrSymbols[i], this.msg.OpenedOrders),
                    cmd:getCmdBySymbol(arrSymbols[i], this.msg.OpenedOrders),
                })
            }
            return result;
        },
        getReportDataClosePositionsBySymbol() {
            if(!this.msg.ClosedOrders || this.msg.ClosedOrders.length === 0)
                return 0
            let arrSymbols = getSymbolPair(this.msg.ClosedOrders);
            let result = []
            for(let i = 0; i < arrSymbols.length; i++) {
                result.push({
                    symbol:arrSymbols[i],
                    volume:getVolumeBySymbol(arrSymbols[i], this.msg.ClosedOrders),
                    price: getAverPrice(arrSymbols[i], this.msg.ClosedOrders),
                    cmd:getCmdBySymbol(arrSymbols[i], this.msg.ClosedOrders),
                    plDepo:getProfitBySymbol(arrSymbols[i], this.msg.ClosedOrders).plDepo,
                    plRel:getProfitBySymbol(arrSymbols[i], this.msg.ClosedOrders).plDepo/(this.getCropStat() ? this.getCropStat().Summary.Equity: 1)*100,
                    plPoint:getProfitBySymbol(arrSymbols[i], this.msg.ClosedOrders).plPoint
                })
            }
            return result;
        },
        getSummaryProfits() {
            if(!this.msg.ClosedOrders)
                return 0
            let arrClosePos = this.getReportDataClosePositionsBySymbol
            if(arrClosePos.length === 0)
                return
            let profits = {
                plDepo:0,
                plRel:0,
                plPips:0,
                volume:0
            }
            if(arrClosePos.length === 1) {
                profits = {
                    plDepo:arrClosePos[0].plDepo,
                    plRel:arrClosePos[0].plRel,
                    plPips:arrClosePos[0].plPoint,
                    volume:arrClosePos[0].volume
                }
            } else {
                for(let i = 1; i < arrClosePos.length; i++) {
                    profits = {
                        plDepo: arrClosePos[0].plDepo+=arrClosePos[i].plDepo,
                        plRel: arrClosePos[0].plRel+=arrClosePos[i].plRel,
                        plPips: arrClosePos[0].plPoint+=arrClosePos[i].plPoint,
                        volume: arrClosePos[0].volume+=arrClosePos[i].volume
                    }
                }
            }
            return profits
        },
        /*profitWeek() {
            if(this.statWeek.week.length === 0) {
                let stat = {
                    profitAbs:0,
                    profitRel:0
                };
                return stat;
            }
            let month = this.statWeek.week[this.statWeek.week.length - 1]
            return month[month.length - 1]
        },
        profitMonth() {
            let stat = {
                profitAbs:0,
                profitRel:0
            };
            if(this.statWeek.week.length === 0) {
                return stat;
            }
            let lastWeek = this.statWeek.week[this.statWeek.week.length - 1];
            stat.profitAbs = lastWeek[lastWeek.length - 2].equityOnEod - this.statWeek.week[0][0].equityOnBod;
            stat.profitRel = 100/(this.statWeek.week[0][0].equityOnBod/stat.profitAbs)
            return stat;
        },
        //profitType() {
            let profits = {
                day:0,
                week:this.profitWeek,
                month:this.profitMonth
            }
            return profits
        },*/
    },
    methods: {
        getHeightTable() {
            this.widthTable = this.$refs.tableOrders.clientWidth;
        }
    },
    mounted() {
        this.getHeightTable();
    },
    created() {
        /*setTimeout(
            ()=> {
                this.statWeek = this.getMonthStat('',new Date(this.msg.ReportDate))
                console.log(this.statWeek);
            },2000
        );*/
    }
}
function getOpenPositions(positions, dateData) {
    let dateDay = new Date (dateData).getDate();
    let dateMoth = new Date (dateData).getMonth();
    let dateYear = new Date (dateData).getFullYear();
    let openPositions = [];
    let closePositions = [];
    for(let i = 0; i < positions.OpenedOrders.length; i++) {
        if(new Date (positions.OpenedOrders[i].timeEnter).getDate() === dateDay && new Date (positions.OpenedOrders[i].timeEnter).getMonth() === dateMoth && new Date (positions.OpenedOrders[i].timeEnter).getFullYear() === dateYear) 
            openPositions.push(positions.OpenedOrders[i])
    }
    for(let i = 0; i < positions.ClosedOrders.length; i++) {
        if(new Date (positions.ClosedOrders[i].timeEnter).getDate() === dateDay && new Date (positions.ClosedOrders[i].timeEnter).getMonth() === dateMoth && new Date (positions.ClosedOrders[i].timeEnter).getFullYear() === dateYear)
            closePositions.push(positions.ClosedOrders[i])
    }
    let allPositions = [...openPositions, ...closePositions]
    return allPositions;
}
function getClosedPositions(positions, dateData) {
    let dateDay = new Date (dateData).getDate();
    let dateMoth = new Date (dateData).getMonth();
    let dateYear = new Date (dateData).getFullYear();
    let closePositions = [];
    for(let i = 0; i < positions.ClosedOrders.length; i++) {
        if(new Date (positions.ClosedOrders[i].timeExit).getDate() === dateDay && new Date (positions.ClosedOrders[i].timeExit).getMonth() === dateMoth && new Date (positions.ClosedOrders[i].timeExit).getFullYear() === dateYear)
            closePositions.push(positions.ClosedOrders[i])
    }
    return closePositions;
}
function getSymbolPair(arr) {
    let symbols = {};
    for (let i = 0; i < arr.length; i++) {
        let str = arr[i].symbol;
        symbols[str] = str;
    }
    return Object.keys(symbols);
}
function getVolumeBySymbol(symbol, arr) {
    let sumVolume = 0
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol)
        sumVolume+=arr[i].volume
    }
    return sumVolume;
}
function getAverPrice(symbol, arr) {
    let sumPrice = 0;
    let cnt = 0;
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol) {
            sumPrice+=arr[i].priceEnter
            cnt++
        }
    }
    return (sumPrice/cnt).toFixed(5);
}
function getCmdBySymbol(symbol, arr) {
    let cntSELL = 0;
    let cntBUY = 0;
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol) {
            arr[i].side === 1 ? cntBUY++ : cntSELL++
        }
    }
    return cntBUY < cntSELL ? -1 : 1
}
function getProfitBySymbol(symbol, arr) {
    let pl = 0;
    let plP = 0;
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].symbol === symbol) {
            pl+=arr[i].resultDepo;
            plP+=arr[i].resultPoint;
        }
    }
    let profits = {
       plDepo:pl,
       plPoint:plP
    }
    return profits
}
Date.prototype.getWeek = function() {
  var onejan = new Date(this.getFullYear(),0,1);
  return Math.ceil((((this - onejan) / 86400000) + onejan.getDay()+1)/7);
}
</script>
<style lang="less" scoped>
.tableWrap {
    position: relative;
}
.tableOverlay {
    position: absolute;
    top:0;
    width: 100%;
    height: 100%;
    background: rgb(0,0,0);
    background: rgb(255,255,255);
    background: linear-gradient(90deg, rgba(255,255,255,0) 56%, rgba(0,0,0,1) 96%);
}
.bigBorder {
    border-bottom: solid #293546 3px !important; 
}
.mainTitle {
    font-size: 13px;
    p {
        font-size: 16px;
    }
}
.reportForWeek {
    //background: #324258;
    //border-left:1px solid #293546;
    font-family: Arimo;
    font-size: 14px;
    line-height: 1.24;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    box-sizing: border-box;
    @media screen and (max-width: 1981px) { 
        
    }
    &-closeIcon {
        width: 100%;
        text-align: right;
    }
    &-title {
        border-bottom: solid #324259 1px;
        padding: 12px;
        align-items: center;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        color: #9cacc6;
        //background:   #324259;
        text-transform: uppercase;
        display: flex;
        justify-content: space-between;
        
        span {
            color:#fff;
        }
        p {
            margin-bottom: 0;
            margin-top: 3px;
            text-transform: none;
            display: flex;
            align-items: center;
            max-height: 23px;
            i.icon-arrow-up {
                padding-top:12px;
            }
        }
        i {
            font-size: 18px;
            margin-right: 8px;
            margin-top: -3px;
            cursor: pointer;
        }
        &-white {
            color:#fff;
        }
    }
    &-rowData {
        height: 30px;
        font-size: 12px;
        padding: 8px;
        box-sizing: border-box;
        color:#9FB6D2;
        text-transform: uppercase;
        display: flex;
        &_symbol {
            width:80px;
            color:#fff;
            font-weight: bold;
        }
        &_cmd {
            width:60px;
        }
        &_volume {
            width: 125px;
            span {
                color:#fff;
            }
        }
        &_price {
            span {
                color:#fff;
            }
        }
    }
    &-summary {
        display: flex;
    }
    &-summaryData {
        min-width: 300px;
        flex-grow: 0;
        &-item {
            height: 30px;
            font-size: 12px;
            padding: 8px;
            box-sizing: border-box;
            color:#9FB6D2;
            text-transform: uppercase;
            span {
                color:#fff;
            }
        }
    }
    &-chart {
        height: 450px;
    }
}
.reportTable {
    width: 100%;
    tr {
        height: 36px;
        border-bottom: 1px solid #324259;
    }
    td,th {
        padding-left: 12px;
        border-right: 1px solid #324259;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.36;
        letter-spacing: 0.4px;
        color: #fff;
        &:last-child {
           border-right: none; 
        }
    }
    th {
        color: #9cacc6;
    }
    &-title {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        color: #9cacc6;
        text-transform: uppercase;
    }
}
.reportSummaryInfo {
    padding: 12px;
    &-item {
        font-family: Arimo;
        display: flex;
        max-height: 20px;
        align-items: center;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 3;
        letter-spacing: 0.4px;
        margin-bottom: 6px;
        span {
            text-transform: uppercase;
            color: #9cacc6;
        }
        i {
            font-size: 18px;
            margin-right: 6px;
        }
        i.icon-arrow-up {
            padding-top: 13px;
        }
        span:last-child {
            font-size: 16px;
            color:#fff;
        }
    }
}
</style>